module.exports = __webpack_public_path__ + "static/media/Fuel_Loan.d1b18f01.webp";